import React from "react";

export const IconsComponentsInstagram = ({ fill }) => {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M48.333 25.0011V25C48.333 12.1331 37.8662 1.66667 25 1.66667C12.1338 1.66667 1.66697 12.1331 1.66697 25C1.66697 37.8669 12.1338 48.3333 25 48.3333C37.8672 48.3333 48.3416 37.8661 48.333 25.0011ZM0 25C0 38.7871 11.2129 50 25 50C38.7871 50 50.0092 38.7871 50 25C50 11.2129 38.7871 0 25 0C11.2129 0 0 11.2129 0 25Z"
        fill={fill}
      />
      <path
        d="M31.8759 17.4032C31.0627 17.4032 30.4034 18.0624 30.4034 18.8755C30.4034 19.6886 31.0627 20.3478 31.8759 20.3478C32.6892 20.3478 33.3485 19.6886 33.3485 18.8755C33.3485 18.0624 32.6892 17.4032 31.8759 17.4032ZM25.3409 19.2857C21.9342 19.2857 19.1649 22.0545 19.1649 25.4606C19.1649 28.8667 21.9342 31.6355 25.3409 31.6355C28.7476 31.6355 31.517 28.8667 31.517 25.4606C31.517 22.0545 28.7476 19.2857 25.3409 19.2857ZM25.3409 29.4161C23.1577 29.4161 21.3847 27.6434 21.3847 25.4606C21.3847 23.2778 23.1577 21.5052 25.3409 21.5052C27.5241 21.5052 29.2971 23.2778 29.2971 25.4606C29.2971 27.6434 27.5241 29.4161 25.3409 29.4161ZM37.8029 20.3258C37.8029 16.1653 34.4328 12.7958 30.2715 12.7958H20.3297C16.1684 12.7958 12.7983 16.1653 12.7983 20.3258V30.2658C12.7983 34.4263 16.1684 37.7958 20.3297 37.7958H30.2715C34.4328 37.7958 37.8029 34.4263 37.8029 30.2658V20.3258ZM35.4438 30.2658C35.4438 33.1225 33.1287 35.4372 30.2715 35.4372H20.3297C17.4725 35.4372 15.1574 33.1225 15.1574 30.2658V20.3258C15.1574 17.4691 17.4725 15.1544 20.3297 15.1544H30.2715C33.1287 15.1544 35.4438 17.4691 35.4438 20.3258V30.2658Z"
        fill={fill}
      />
    </svg>
  );
};
